// Undo/redo: a list of document snapshots (spec §6). PURE — every function returns a new history.
// One entry per completed gesture; the caller decides when a gesture is complete.
export const HISTORY_CAP = 50;

const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export const createHistory = (doc) => ({ past: [], present: doc, future: [] });

// Record `doc` as the new present. A snapshot equal to the present is ignored (a blur without an
// edit must not add an undo step). Recording after an undo drops the redo branch.
export function record(h, doc) {
  if (same(h.present, doc)) return h;
  return { past: [...h.past, h.present].slice(-(HISTORY_CAP - 1)), present: doc, future: [] };
}
export const canUndo = (h) => h.past.length > 0;
export const canRedo = (h) => h.future.length > 0;
export function undo(h) {
  if (!canUndo(h)) return h;
  return { past: h.past.slice(0, -1), present: h.past[h.past.length - 1], future: [h.present, ...h.future] };
}
export function redo(h) {
  if (!canRedo(h)) return h;
  return { past: [...h.past, h.present], present: h.future[0], future: h.future.slice(1) };
}
